import React from 'react'
import { observer } from 'mobx-react-lite'
import { SubscriptionProductsTable } from '../subscription-products-table'
import { Box } from '@mui/material'

interface SubscriptionProductsProps {
  onEdit?: (product: any) => void
}

const SubscriptionProducts: React.FunctionComponent<SubscriptionProductsProps> = observer(
  ({ onEdit }) => {
    return (
      <Box pb="40px">
        <SubscriptionProductsTable onEdit={onEdit} />
      </Box>
    )
  },
)

export const SubscriptionProductsTab = (onEdit?: (product: any) => void) => () => ({
  name: 'Subscriptions',
  path: `/activities/subscriptions`,
  component: () => <SubscriptionProducts onEdit={onEdit} />,
})
